var map = {
	"./10.svg": 80460,
	"./11.svg": 32139,
	"./2.svg": 87077,
	"./3.svg": 65859,
	"./4.svg": 98555,
	"./5.svg": 42894,
	"./6.svg": 7421,
	"./7.svg": 17262,
	"./8.svg": 56176,
	"./9.svg": 90104
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99982;